import { useCallback } from "react";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import useOpenThoughtRecord from "./useOpenThoughtRecord";
import { generateThoughtRecordKey } from "logic/logics";
import { selectedThoughtRecordKeyAtom } from "recoil/selectedThoughtRecordAtom";

export default function useOpenNewThoughtRecord() {
  const patientState = useRecoilValue(patientAtom);
  const resetSelectedThoughtRecordKey = useResetRecoilState(
    selectedThoughtRecordKeyAtom
  );

  const newThoughtRecordKey = generateThoughtRecordKey(
    patientState?.patientId!!
  );

  const openThoughtRecord = useOpenThoughtRecord(newThoughtRecordKey);

  const openNewThoughtRecord = useCallback(() => {
    // Reset any previously selected thought record before opening a new one
    resetSelectedThoughtRecordKey();
    openThoughtRecord();
  }, [resetSelectedThoughtRecordKey, openThoughtRecord]);

  return openNewThoughtRecord;
}
